<div class="wrapper">
	<h2 class="title">
		{{ 'delivery_status_dialog.main_text' | translate: {provider:
		data.providerText} }}
	</h2>
	<div class="footer-btn">
		<button class="dismiss" (click)="close()">
			<h3>{{ 'common.close' | translate }}</h3>
		</button>
	</div>
</div>
